import type { Middleware } from '@nuxt/types';
import { REFERRAL_PRE_ONBOARDING_PAGE, INDEX_PAGE, SIGN_UP_MODAL } from '~/constants';

/**
 * Middleware to route users according to their marker (referral, connections, university) and invite type
 */
const markingMiddleware: Middleware = ({ route: { name, query }, app: { $cookies }, $auth, redirect }) => {
  const marker = query.mrk || query.marker;
  const inviteType = query.invite_type;
  const invitationHash = query.invitation_hash;
  const markerLifespanInDays = 30;
  const markerCookieParams = { maxAge: 60 * 60 * 24 * markerLifespanInDays, path: '/' };

  const hasInvitation = marker || invitationHash;

  if (marker) {
    $cookies.set('marker', marker, markerCookieParams);
  }
  if (invitationHash) {
    $cookies.set('invitation_hash', invitationHash, markerCookieParams);
  }

  // If connection or university email
  if (inviteType && hasInvitation && !$auth.loggedIn) {
    const { invitation_hash, mrk, marker, ...queryParams } = query;

    redirect({
      ...INDEX_PAGE,
      query: {
        dynamic_modal: SIGN_UP_MODAL,
        ...queryParams,
      },
    });
  }

  const isPreOnboardingPage = name === REFERRAL_PRE_ONBOARDING_PAGE.name;
  const canSeePreOnboardingPage = hasInvitation && !isPreOnboardingPage && !$auth.loggedIn;
  if (canSeePreOnboardingPage) {
    redirect({ ...REFERRAL_PRE_ONBOARDING_PAGE, query: { ...query } });
  }
};

export default markingMiddleware;
